import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-custom-file-field',
  templateUrl: './custom-file-field.component.html',
  styleUrls: ['./custom-file-field.component.css']
})
export class CustomFileFieldComponent {
  @Input() id: string;
  @Input() controlName: string;
  @Input() key: string;
  @Input() form: FormGroup;
  @Input() class = 'field';
  @Input() accept: string;
  @Input() hideErrors = false;
  @Output() fileChanged = new EventEmitter<File>();
  @ViewChild('error') error;
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/custom-file-field/custom-file-field.component.ts